import { User } from '../models/user.model';

export class LoadUserAction {
  static readonly type= '[User] Load user';
  constructor() {}
}


 export class LogOutAction {
  static readonly type= '[User] esegue il logout';
  constructor() {}
}

export class LogInAction {
  static readonly type= '[User] esegue il login';
  constructor(public user: User) {}
}

export class SyncStart {
  static readonly type= '[User] syncStart';
  constructor() {}
}


export class SyncStop {
  static readonly type= '[User] syncStop';
  constructor() {}
}


export class SyncError {
  static readonly type= '[User] syncError';
  constructor() {}
}


